import { type Ref, ref } from 'vue'

import { handleErrorMessage } from './error.helpers'

import { useErrorStore } from '@/stores/error.stores'

export const useApi = <T extends Record<string, (...args: never[]) => Promise<unknown>>>(
  methods: T,
): T & {
  loading: Ref<boolean>
  error: Ref<Error | null>
} => {
  const loading = ref<boolean>(false)
  const error = ref<Error | null>(null)
  const errorStore = useErrorStore()

  const wrappedMethods = Object.fromEntries(
    Object.entries(methods).map(([key, method]) => [
      key,
      async (...args: never[]) => {
        loading.value = true
        error.value = null
        try {
          return await method(...args)
        } catch (e) {
          error.value = e as Error
          errorStore.setError(handleErrorMessage(e))
        } finally {
          loading.value = false
        }
      },
    ]),
  ) as T

  return {
    loading,
    error,
    ...wrappedMethods,
  }
}
